exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc-p[data-v-2ff6a5fc] {\n  min-height: 6rem;\n}", ""]);

// exports
